/**
 * A utility function to generate indexes for topojson dynamically.
 *
 * The structure is an object with the value to match on (as lower case) as the key,
 * and the feature index within the topojson as the value.
 *
 * We assume last-one-wins for matches if there's a collision, and we're resilient to missing attributes.
 * This handles only exact matches, but for Chropleths this is sufficient.
 *
 * @param {Object} geometry A topojson or geojson object with features & attributes
 * @param {Array} attributes The array of attributes which we're indexing by
 * @returns {Object} Object of attributes to feature index
 */
function topojsonIndex(geometry, attributes) {
  if (!geometry || (!geometry.features && !geometry.objects)) {
    return {};
  }

  // TopoJSON keeps its features under the first entry the 'objects' object
  const topojsonGeometry = Object.values(geometry.objects || {})[0];

  const features =
    geometry.features || (topojsonGeometry ? topojsonGeometry.geometries : []);

  const index = features.reduce((acc, feature, featureIdx) => {
    if (feature.properties) {
      attributes.forEach(attribute => {
        const value = feature.properties[attribute];
        if (value !== undefined) {
          const processedKey =
            typeof value === 'string' ? value.toLowerCase() : value;
          acc[processedKey] = featureIdx;
        }
      });
      return acc;
    }
  }, {});

  return index;
}

export default topojsonIndex;
export { topojsonIndex };
